import React from 'react';
import Coverimg from './components/Coverimg';
import Heading from './components/Heading';
import AboutCard from './components/AboutCard';
import Timeline from './components/Timeline';
import Skills from './components/Skills';
import ProjectCategoryList from './components/ProjectCategoryList';
import Highlights from './components/Highlights';
import Footer from './components/Footer';
function Home() {
    return (
        <div>
            <Coverimg />
            <div className="wholeContainer">
                <div className="containerDetails">
                    <Heading name="About" id="heading" />
                    <AboutCard />
                    <Timeline />
                    <Heading name="Skills" id="heading" />
                    <Skills />
                    <Heading name="Projects" id="heading1" />
                    <ProjectCategoryList />
                    <Heading name="Highlights" id="heading" />
                    <Highlights />
                    <Footer />
                </div>
            </div>
        </div>

    );
}

export default Home;